<template>
    <div style="width: 100%; display: block">
        <VueFileAgent
            ref="vueFileAgent"
            :theme="'list'"
            :multiple="true"
            :deletable="true"
            :meta="true"
            :accept="'.zip,.pdf,.dwg'"
            :maxSize="'150MB'"
            :maxFiles="50"
            @select="filesSelected($event)"
            @beforedelete="onBeforeDelete($event)"
            @delete="fileDeleted($event)"
            @upload="uploaded"
            v-model="fileRecords"
        ></VueFileAgent>

        <button :disabled="loading" class="btn btn-upload btn-primary" @click="uploadFiles">Upload <span class="loading fa" :class="{'fa-sync': loading, 'fa-spin':loading}"></span></button>
    </div>
</template>

<script>
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';

export default {
    name: "MUpload",
    comments: {
        VueFileAgent
    },
    props: {
        setName: {
            type: String,
            default: 'name'
        }
    },
    data: function () {
        return {
            fileRecords: [],
            loading: false,
            uploadUrl: '/word/upload',
            uploadHeaders: {
                'X-Test-Header': 'vue-file-agent',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            fileRecordsForUpload: [], // maintain an upload queue
        };
    },
    methods: {
        uploadFiles: function () {
            this.loading = true;
            this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
            this.fileRecordsForUpload = [];
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        filesSelected: function (fileRecordsNewlySelected) {
            let filename = fileRecordsNewlySelected[0].file.name;
            $(`#${this.setName}`).val(filename.substr(0, filename.lastIndexOf('.')))
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
            //this.uploadFiles()
        },
        onBeforeDelete: function (fileRecord) {
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                var k = this.fileRecords.indexOf(fileRecord);
                if (k !== -1) this.fileRecords.splice(k, 1);
            } else {
                if (confirm('Are you sure you want to delete?')) {
                    this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
                }
            }
        },
        fileDeleted: function (fileRecord) {
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                this.fileRecordsForUpload.splice(i, 1);
            } else {
                this.deleteUploadedFile(fileRecord);
            }
        },
        uploaded(response) {
            showMessage('s', 'Successfully uploaded!')
            this.loading = false;
            this.fileRecords = [];
            setTimeout(function (){
                window.location.reload()
            }, 500)

        }
    },
}
</script>

<style scoped>

</style>
